<template>
    <paper>
        <mPane
            ref="tablePage"
            :config="config"
            :loading="loading"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :currentPage="page.pageNo"
            :pickerConfig="config.pickerConfig"
            :searchTotalTitle="config.searchTotalTitle"
            moduleCode="OneCarOneCheckManageLSP"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @onCellDblclick="cellDBClick"
            @adjust-approver-btn="handleAdjustApprover">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_CAR_CHECK">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <!-- 上表格展开行插槽 -->
            <template slot="expand-table-cont" slot-scope="{ expandTable }">
                <expand-table-content
                    :contentTableData="expandTable"
                    :dictData="dictData"
                    @btnEvent="btnEvent"
                ></expand-table-content>
            </template>
            <!-- 上表格展开行插槽 -->
        </mPane>

        <!-- 查看附件 -->
        <performance-preview-file
            ref="performancePreviewFile"
            :attachmentList="tableAttachmentList"
        ></performance-preview-file>
        <!-- 同意原因 -->
        <ApproveReasonDialog ref="approveReasonDialogRef" />
        <!-- 调整审批人 -->
        <otpAdvanceMultiDialog ref="advanceDialogRef" @confirm="handleAdjustApproverSubmit"/>
    </paper>
</template>

<script>

import config from './config.js';
import { getSearchList, queryCount, batchAdjustApprove } from '@/modules/transport/otp/api/carCheck.js';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { searchFieldSeperated } from '@/modules/transport/otp/utils/searcher.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { toString, cloneDeep} from 'lodash';
import { strToArray, waitTimes, parseUserStrToobject } from '@/modules/transport/otp/utils/commonFun.js';
import { removeFalsyValues, validateSearchTime, formatRouteParams, setValue, setAllPropertyValuesToNull } from './util.js';

import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import reportExport from '@/components/lots/reportExportPlugin';
import ExpandTableContent from './ExpandTableContent.vue';// 查看附件
import PerformancePreviewFile from './component/PerformancePreviewFile.vue';
import ApproveReasonDialog from './component/ApproveReasonDialog.vue';
import otpAdvanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';

export default {
    name: 'carCheck',
    components: {
        paper,
        mPane,
        reportExport,
        ExpandTableContent,
        PerformancePreviewFile,
        ApproveReasonDialog,
        otpAdvanceMultiDialog
    },
    data () {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            uploadVisible: false,
            page: {
                pageSize: 10,
                pageNo: 1
            },
            dictData: {},
            searchParams: {},
            exportParams: {},
            tableAttachmentList: [], // 列表附件查看列表
            isFirstSearch: true
        };
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant,
            user: state => state.user,
            supplier: state => state.supplier,
        }),

    },

    beforeRouteEnter (to, from, next) {
        if (['/order-workbench'].includes(from.path)) {
            next(vm => {
                vm.$nextTick(() => {
                    if (vm.$route.params && Object.keys(vm.$route.params).length) {
                        vm.handleJumpSearch();
                    }
                });
            });
        } else {
            next();
        }
    },
    mounted () {
        this.getDictData();
    },
    methods: {
        async handleJumpSearch () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            const [outerSearchData, innerSearchData, keyMap] = formatRouteParams(this.$route.params, config);
            setValue(this.$refs.tablePage.$refs.searchList.searchData, outerSearchData);
            this.$refs.tablePage.$refs.searchList.keyMap = keyMap;
            this.loading = true;
            this.searchParams = {
                ...this.formatSearchData({ ...outerSearchData, ...innerSearchData })
            };
            await this.getDictData();
            await Promise.all([ this.getDataList(), this.getListPageCount() ])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        // 展开指定的行，入参为行id
        async expandRowById(rowId) {
            const tableRef = this.$refs.tablePage.$refs.table.$refs.moduleTable;
            await this.$nextTick();
            if (tableRef) {
                const target = tableRef.data.find(item => item.id === rowId);
                target && tableRef.toggleRowExpansion(target, true);
            }
        },

        btnEvent(event, attach, rowData) {
            const strategy = {
                photos: () => this[`${event}Btn`](attach), // 附件查看
                approve: () => {
                    // 同意成功回调：刷新数据且自动展开当前行
                    const onSuccess = async () => {
                        await this.getDataList();
                        await waitTimes(50);
                        this.expandRowById(rowData.id);
                    };
                    this.$refs.approveReasonDialogRef.open(rowData, attach, onSuccess);
                }
            };
            const handle = strategy[event];
            if (handle) handle();
        },
        // 查看发车照片
        photosBtn (row) {
            const listKey = `${row.picType}List`;
            this.tableAttachmentList = [];
            this.tableAttachmentList = row[listKey].map(item => {
                return {
                    updateUserName: item.uploadUserName,
                    updateTime: item.uploadTime,
                    path: item.picUrl
                };
            });
            this.$nextTick(() => {
                this.$refs.performancePreviewFile.show();
            });
        },
        formatSearchData(data) {
            const params = cloneDeep(data);
            if (params.customerCode) {
                params.customerCodeList = params.customerCode.split(',');
                params.customerNameList = params.customerName.split(',');
            }
            if (params.siteCode) {
                params.siteCodeList = params.siteCode.split(',');
                params.siteNameList = params.siteName.split(',');
            }
            params.dispatchNoList = searchFieldSeperated(params.dispatchNo || '');
            if (params.createTime) {
                params.createTimeStart = dayjs(params.createTime[0]).format('YYYY-MM-DD HH:mm:ss');
                params.createTimeEnd = dayjs(params.createTime[1]).format('YYYY-MM-DD HH:mm:ss');
            } else {
                params.createTimeStart = '';
                params.createTimeEnd = '';
            }
            params.carrierCode = this.supplier.supplierCode; // 供应商端需要加上供应商编码入参
            delete params.dispatchNo;
            delete params.customerCode;
            delete params.customerName;
            delete params.siteCode;
            delete params.siteName;
            delete params.createTime;
            return params;
        },
        searchChange (data) {
            if (!data.dispatchNo && !data.createTime) {
                return this.$message.warning('发车单号 和 创建时间 不可同时为空');
            }
            if (!validateSearchTime(data, 'createTimeStart', 'createTimeEnd', 31)) {
                return false;
            }
            if (searchFieldSeperated(data.dispatchNo || '').length > 100) {
                return this.$message.warning('按发车单号查询时，最多支持查询100单！');
            }

            // 格式化查询条件
            this.page.pageNo = 1;
            const _searchData = this.formatSearchData(data);
            this.searchParams = {
                ..._searchData,
                pageNo: 1
            };
            this.exportParams = { ...this.searchParams };
            this.getListPageCount();
            this.getDataList();
        },
        // 单元格双击
        cellDBClick(row, column, cell, event) {
            if (column.property === 'dispatchNo') {
                // 发车单双击，跳到发车单详情
                event.stopPropagation();
                this.gotoDispatchDetail(row);
            }
        },
        pageChange (pageNo) {
            this.page.pageNo = pageNo;
            this.getListPageCount();
            this.getDataList();
        },
        sizeChange (pageSize) {
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.exportParams = { ...this.searchParams };
            this.getListPageCount();
            this.getDataList();
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                param: {
                    ...data
                }
            };
            _searchData.param = removeFalsyValues(_searchData.param);
            return _searchData;
        },
        /**
         * @description 获取列表分页数据
         */
        getListPageCount () {
            const params = this.getSearchData(this.searchParams);
            queryCount(params.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        async getDictData () {
            const dict = await dictWithUrl([
                'CAR_CHECK_STATUS',
                'LMDM_CUSTOMER_CHANNEL',
                'SYS_PROFESSIONAL_COMPANY',
                'TMS_SHIPPING_TYPE',
                'TMS_AI_RESULT', // AI分析结果
                'CAR_CHECK_MANAGE_APPROVA_STATUS', // 审批状态
                'TMS_INSPECTION_APPROVE_REASON' // 同意原因
            ].join(','));
            this.dictData = dict.data;
        },
        /**
         * @param {number} expandId 自动展开行的id, 如果未传入或未找到该id数据，则默认展开第一行。
         */
        async getDataList (expandId) {
            this.isFirstSearch = false;
            this.loading = true;
            const params = this.getSearchData(this.searchParams);
            return getSearchList(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(item => {
                        item.statusName = this.dictData.CAR_CHECK_STATUS[item.inspectionStatusBig] || item.inspectionStatusBig;
                        item.customerAttribute = this.dictData.LMDM_CUSTOMER_CHANNEL[item.customerAttribute] || item.customerAttribute;
                        item.shippingTypeStr = this.dictData.TMS_SHIPPING_TYPE[item.shippingType] || item.shippingType;
                        item.approveStatus = toString(item.approveStatus); // 转字符类型
                    });
                    this.totalData = res.data.list;
                }
            }).finally(() => {
                this.loading = false;
                setTimeout(() => {
                    const expandTarget = expandId ? this.totalData.find(item => item.id === expandId) : null;
                    const row = expandTarget || this.totalData[0];
                    if (row) this.expandRowById(row.id);
                }, 800);
            });
        },
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            // 导出手动添加自定义字段
            let requestResults = this.$refs.tablePage.tableList + [',空车照片', '空车照片提交时间', '车头照片', '车头照片提交时间', '装车货物照片', '装车货物照片提交时间', '封车照片', '封车照片提交时间'].join(',');
            requestResults += ',空车照片AI结果,空车照片异常原因,车头照片AI结果,车头照片异常原因,装车货物照片AI结果,装车货物照片异常原因,封车照片AI结果,封车照片异常原因';
            requestResults += ',空车照片审批状态,空车照片审批人,空车照片审批时间,空车照片审批备注,车头照片审批状态,车头照片审批人,车头照片审批时间,车头照片审批备注,装车货物照片审批状态,装车货物照片审批人,装车货物照片审批时间,装车货物照片审批备注,封车照片审批状态,封车照片审批人,封车照片审批时间,封车照片审批备注';
            const exportParam = {
                ...this.searchParams,
                tenantCode: this.currentTenant.tenantCode,
                requestResults,
                beginDate2: '2020-11-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate2: '2020-11-27 00:00:00'
            };
            for (const key in exportParam) {
                if (exportParam[key] === '' || (Array.isArray(exportParam[key]) && exportParam[key].length === 0)) {
                    delete exportParam[key];
                }
            }
            submit(exportParam);
            this.isFirstSearch = false;
        },
        // 跳转到发车单详情
        gotoDispatchDetail(rowData) {
            this.$router.push({
                path: '/performance/dispatch-order-detail',
                query: {
                    dispatchNo: rowData.dispatchNo
                }
            });
        },
        // 调整审批人按钮
        handleAdjustApprover(row) {
            const config = {
                name: '调整审批人',
                multiple: true,
                maxNum: 9,
                notEncodeURIComponent: true, // 查询参数不进行编码
                hideTooltip: true,
                advanceConfig: [
                    { prop: 'queryParam', value: 'mip账号或名字' }
                ],
                tableConfig: [
                    { prop: 'userCode', value: 'mip账号', width: 120 },
                    { prop: 'userName', value: '姓名', width: 100, 'displayName': true },
                    { prop: 'orgName', value: '所属组织' }
                ],
                prefix: '/api-auth/',
                advanceUrl: 'tenantUserInfos',
                cbParams: ['userName', 'userCode', 'orgName'],
                advanceCascade: {},
                __row__: row // 保存当前行数据，用于弹窗提交回调函数中使用
            };
            const checkedList = strToArray(row.approverCodeList).map(item => {
                // 将“黄3989(ex_huangjy29)” 解析成对象
                return parseUserStrToobject(item);
                // const [userName, userCode] = (item || '').replace(')', '').split('(');
                // return { userName, userCode };
            });
            this.$refs.advanceDialogRef.show(true, config, config.advanceCascade, checkedList);
        },
        // 调整审批人提交
        async handleAdjustApproverSubmit(data, config) {
            const row = config.__row__;
            const reqData = {
                idList: [row.id],
                approveCode: data.map(item => item.userCode).join(','),
                approveName: data.map(item => `${item.userName}(${item.userCode})`).join(',')
            };
            const res = await batchAdjustApprove(reqData);
            if (res && +res.code === 0) {
                this.$message.success('调整审批人成功');
                this.getListPageCount();
                this.getDataList(row.id);
            }
        }
    }
};
</script>
<style lang="less" scoped>
:deep(.el-table__expanded-cell) {
    padding: 20px 50px 0!important;
}
</style>
